import React, { useEffect } from "react";
import { View, Card, Text } from "react-native-ui-lib";

export const contactLedgerfields = (response, view = false, moduleName = null, OpenModalCustom, value, isEdit, globalData, setGlobalData) => {
    const formFields = [
        {
            label: 'Name',
            key: 'name',
            type: 'text',
            placeholder: 'Enter the contactLedger name',
            visible: true,
            width: '25%',
            viewField: true,
        },
        {
            label: 'Description',
            key: 'description',
            type: 'text',
            placeholder: 'Enter the contactLedger description',
            visible: true,
            width: '25%',
            viewField: true,
        },
        {
            label: 'Active',
            key: 'active',
            type: 'switch',
            placeholder: 'Is the contactLedger active?',
            visible: true,
            width: '25%',
        },
        {
            label: 'Type',
            key: 'type',
            type: 'text',
            placeholder: 'Enter the contactLedger type',
            visible: true,
            width: '25%',
            viewField: true,
        },
        {
            label: 'Base Type',
            key: 'base_type',
            type: 'text',
            placeholder: 'Enter the base contactLedger type',
            visible: true,
            width: '25%',
            viewField: true,
        },
    ];

    const CustomFields = response.CustomFields;

    if (CustomFields && CustomFields.length > 0) {
        CustomFields.forEach((field) => {
            formFields.push({
                label: field.name,
                key: 'cf.' + field.key,
                type: field.type,
                placeholder: field.placeholder,
                visible: true,
                width: '25%',
                viewField: true,
            });
        });
    }

    return formFields;
}

export const contactLedgerMobileCard = (item, index, getFieldValue) => {
    return <Card flex margin-20 padding-15 className="hh" style={{ height: 100, marginVertical: 10, flexDirection: 'row', flexWrap: 'wrap' }}>
        <View>
            <Text>TEST</Text>
            <Text style={{ marginBottom: 5 }}>{getFieldValue(item, 'name') ? "" + getFieldValue(item, 'name') : ""}</Text>
        </View>
    </Card>;
}

export const contactLedgerMain = {
    fields: contactLedgerfields,
    mobileCard: null
}